import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me2.jpg`} alt="" />
      </Link>
      <header>
        <h2>Serin Choi</h2>
        <p><a href="mailto:choi.serin1795@gmail.com">choi.serin1795@gmail.com</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>Hi, I’m Serin. I am a UC Irvine graduate making a career in
        Finance specifically in Financial Planning and Analysis.
        I currently possess 2 certifications (CFI and Coursera)
        and am contemplating pursuing the CMA Certification to
        further enhance my professional qualifications.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">&copy; Serin Choi <Link to="/">serinchoi.com</Link>.</p>
    </section>
  </section>
);

export default SideBar;
